<template>
	<div
		class="nav-dropdown"
	>
		<button 
			class="flex flex-row justify-center items-center"
			@click="toggleDropdown"
		>
			{{ label }}
			<UiIcon v-if="isDropdownVisible" name="chevronUp"/>
			<UiIcon v-else name="chevronDown"/>
		</button>
		<transition 
      @before-enter="beforeExpand" @enter="expanded"
      @before-leave="beforeCollapse" @leave="collapsed"
		>
			<div 
				v-show="isDropdownVisible"
				class="dropdown-list overflow-hidden animate--collapsible absolute inset-x-0 bg-bg-001 text-text-001 shadow-default"
			>
				<div class="container py-8">
					<CategoryList 
						:cols="listCols" 
						:config="{
							'Featured': 1,
							'Therapeutic Areas':  taCols
						}"
					/>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiIcon from '@/components/ui/Icon'
import CategoryList from '@/components/category/List'

export default {
	name: 'CategoryDropdown',
	props: {
		label: {
			type: String,
			default: 'Dropdown'
		},
		list: {
			type: Array,
			default: () => []
		},
		rows: {
			type: Number,
			default: 5
		}
	},
	components: {
		UiIcon,
		CategoryList
	},
	mixins: [
		globalMixins
	],
	data() {
		return {
			isDropdownVisible: false,
			screenSize: null
		}
	},
	computed: {
		listCols() {
			return this.screenSize === 'mobile' || this.screenSize === 'tablet'
				? 4
				: 5
		},
		taCols() {
			return this.screenSize === 'mobile' || this.screenSize === 'tablet'
				? 3
				: 4 
		}
	},
	watch: {
		$route() {
			this.unfocus()
		}
	},
	mounted() {
		this.setScreenSize()
	},
	beforeMount() {
    window.addEventListener('scroll', this.unfocus);
    window.addEventListener('resize', this.resize);
	},
  beforeUnmount() {
    window.removeEventListener('scroll', this.unfocus);
    window.removeEventListener('resize', this.resize);
  },
	methods: {
		resize() {
			this.unfocus()
			this.setScreenSize()
		},
		setScreenSize() {
			this.screenSize = window.innerWidth > 769 && window.innerWidth <= 1024
				? 'tablet'
				: window.innerWidth > 1024 && window.innerWidth <= 1280
				? 'laptop'
				: window.innerWidth > 1280 && window.innerWidth <= 1920
				? 'desktop'
				: window.innerWidth > 1920
				? 'tv'
				: 'mobile'
		},
		toggleDropdown() {
			this.isDropdownVisible = !this.isDropdownVisible
		},
		unfocus() {
			if (this.isDropdownVisible) {
				this.isDropdownVisible = false
			}
		}
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>